import { type BlogFrontmatter } from "@/services/blog.ts";
// eslint-disable-next-line no-restricted-imports
import headerImage from "./header_image.avif";
// eslint-disable-next-line no-restricted-imports
import { height, width } from "./header_image.avif?as=metadata:height;width";
// eslint-disable-next-line no-restricted-imports
import headerImageSrcset from "./header_image.avif?w=480;960;1920&format=avif&as=srcset";

export const frontmatter: BlogFrontmatter = {
  title: "Shipped and secured: Controla’s 2026 product updates so far",
  header:
    "Shipped and secured: What we added, fixed, and improved so far in 2026",
  date: "2026-09-30",
  description:
    "Explore what’s new in Controla: easier onboarding, clearer tasks, backup with 50 GB of storage, more control for admins, and a refreshed website.",
  category: "product",
  draft: false,
  authorKey: "thea_naree",
  headerImage,
  headerImageSrcset,
  headerImageDimensions: {
    height,
    width,
  },
};
